import Select from "react-select";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_COURSE_MODULE_GROUPS} from "../../api/service";
import {CreateFilterEncoding, CreatePaginationEncoding} from "../../Utils/Base64/request";


export const CourseModuleGroupTypeahead = ({
                                               courseID = 0,
                                               onChange,
                                               refresh = false,
                                               defaultID = 0,
                                               onRefreshFinish,
                                               isMulti = false
                                           }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [options, setOptions] = useState([])
    const [selected, setSelected] = useState([])

    const [cid, setCID] = useState(courseID)

    useEffect(() => {
        if (refresh === true) {
            setSelected([])
            onRefreshFinish()
        }
    }, [refresh])

    useEffect(() => {
        if (defaultID !== 0) {
            setIsLoading(true);
            axios.get(API_COURSE_MODULE_GROUPS + "/?pagination=" + CreatePaginationEncoding(1, 0) + "&filter=" + CreateFilterEncoding({
                id: defaultID,
            })).then(r => {
                if (r.status === 200) {
                    return r.data["data"]
                }
            }).then(json => {
                if (json.data) {
                    setSelected(json.data.length > 0 ? json.data[0] : [])
                } else {
                    setSelected([])
                }
            }).finally(() => {
                setIsLoading(false);
            })
        }
    }, [defaultID])


    useEffect(() => {
        setCID(courseID)
        loadCourseModuleGroup(10, 0, {
            course_id: cid
        })
    }, [courseID])

    const loadCourseModuleGroup = (limit = 10, offset = 0, filter = {}) => {
        if (courseID !== 0) {
            setIsLoading(true);
            axios.get(API_COURSE_MODULE_GROUPS + "/?pagination=" + CreatePaginationEncoding(limit, offset) + "&filter=" + CreateFilterEncoding(filter)).then(r => {
                if (r.status === 200) {
                    return r.data["data"]
                }
            }).then(json => {
                if (json.data) {
                    setOptions(json.data.length > 0 ? json.data : [])
                } else {
                    setOptions([])
                }
            }).finally(() => {
                setIsLoading(false);
            })
        }
    }

    const handleInputChange = (e, m) => {
        loadCourseModuleGroup(10, 0, {
            title: e,
            course_id: cid
        })
    }

    useEffect(() => {
        loadCourseModuleGroup(10, 0, {
            course_id: cid
        })
    }, [])

    const handleOnChange = (newValue) => {
        setSelected(newValue)
        onChange(newValue)
    }

    return (
        <>
            <Select
                getOptionLabel={(opt) => `${opt.title}`}
                value={selected}
                getOptionValue={(opt) => `${opt.title}`}
                onChange={(newValue, m) => {
                    handleOnChange(newValue)
                }}
                onInputChange={handleInputChange}
                options={options}
                loadOption={isLoading}
                className="js-example-basic-single col-sm-12"
                isMulti={isMulti}/>
        </>
    )
}
